export const chatList = [
  {
    id: "user1",
    name: "Ahsan Khan",
    lastMessage: "I need help with the order",
    unreadCount: 2,
    avatar: "https://randomuser.me/api/portraits/men/32.jpg",
    isOnline: true,
    lastSeen: null, 
  },
  {
    id: "user2",
    name: "Sara Ali",
    lastMessage: "Thanks for the support!",
    unreadCount: 15,
    avatar: "https://randomuser.me/api/portraits/women/44.jpg",
    isOnline: false,
    lastSeen: "2025-06-18T14:25:00Z", 
  },
];
